import { Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { Observable } from 'rxjs/Observable'; 
import {userlist, chatData, showChat} from './chat';
import {Store} from '@ngrx/store';
import {AngularFireAuth} from 'angularfire2/auth';
import {AngularFireDatabase, FirebaseObjectObservable, FirebaseListObservable} from 'angularfire2/database';


@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit {

      public userlist:userlist[]=[];
     public searchUserData:userlist[]=[];
     
     chatUserId: Observable<string>;
     length:number = 0;
     searchName:any;
    constructor(public af:AngularFireAuth,
    	        public db:AngularFireDatabase,
    	        public router:Router,
                public storeData:Store<showChat>) {
      this.chatUserId = storeData.select('data');
      console.log("chat userId"+ this.chatUserId);
      this.db.list('/messages').subscribe(res=>{
      	console.log(JSON.stringify(res)+"res");
        if(res.length>0){
          this.userlist = res;
          console.log("user list"+ JSON.stringify(this.userlist));
        }
      	
      })
    }

// User List
    goToUserChat(userId){

      this.storeData.dispatch({ type: userId });
    }

  ngOnInit() {
   // this.storeData.dispatch({ type:  this.userlist  });
  }

}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/routes/restaurant/chat/chat.component.ts